import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotBox = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Property_1=on,_Property_2=40_svg__a)">
            <path
                fill={spotColor}
                d="M34.4 39.076c-6.746 2.775-12.172-1.247-18.456-4.857C9.534 30.002-.79 31.317.048 22.86c.665-6.725 8.407-7.027 14.496-11.029C20.6 7.835 23.221 5.904 28.44 7.638c5.183 1.739 10.16 5.108 11.292 11.247 1.098 6.143-1.28 17.657-5.332 20.19Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M5.45 11.6 20 20.015l14.55-8.417M20 36.8V20m15 6.668V13.333a3.333 3.333 0 0 0-1.667-2.883L21.667 3.784a3.334 3.334 0 0 0-3.334 0L6.667 10.45A3.333 3.333 0 0 0 5 13.334v13.333a3.333 3.333 0 0 0 1.667 2.883l11.666 6.667a3.333 3.333 0 0 0 3.334 0l11.666-6.667A3.334 3.334 0 0 0 35 26.667Z"
            />
        </g>
        <defs>
            <clipPath id="Property_1=on,_Property_2=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotBox.displayName = "SpotBox";
